module.exports = __webpack_public_path__ + "static/media/spin-wheel-arrow.9f13a189.png";